import { ColorScale, purple } from 'bold-ui/lib/styles/colors'
import preNatalIcon from 'images/soap/ic_pre-natal.png'

export interface AcompanhamentoSideMenuItem {
  title: AcompanhamentoMenuTitle
  icon: string
  alt: string
  color: ColorScale
  subItems: ReadonlyArray<{ title: string; to: string }>
}

export type AcompanhamentoMenuTitle = 'Pré-natal'

export const getAcompanhamentosSideMenuItems = (): AcompanhamentoSideMenuItem[] =>
  // TODO ROYAL FLUSH 25842: Implementar os anchors
  [
    {
      title: 'Pré-natal',
      icon: preNatalIcon,
      alt: 'Ícone de uma mulher grávida',
      color: purple,
      subItems: [
        {
          title: 'Antecedentes obstétricos',
          to: '#antecedentes-obstetricos',
        },
        {
          title: 'Progresso da gestação',
          to: '#',
        },
        {
          title: 'Informações da gestação atual',
          to: '#informacoes-gestacao-atual',
        },
        {
          title: 'Acompanhamento de vulnerabilidades',
          to: '#acompanhamento-vulnerabilidade',
        },
        {
          title: 'Medições da gestante',
          to: '#',
        },
        {
          title: 'Medicamentos em uso',
          to: '#medicamentos-em-uso',
        },
        {
          title: 'Lista de problemas e condições',
          to: '#lista-problemas-condicoes',
        },
        {
          title: 'Problemas/condições autorreferidas',
          to: '#',
        },
        {
          title: 'Consultas de pré-natal',
          to: '#',
        },
        {
          title: 'Vacinação',
          to: '#',
        },
        {
          title: 'Visitas domiciliares',
          to: '#',
        },
        {
          title: 'Exames',
          to: '#',
        },
        {
          title: 'Próximo(s) agendamento(s)',
          to: '#',
        },
      ],
    },
  ]
